import { useState, useEffect } from 'react';
import { api } from '../lib/api';

export interface SearchResult {
  id: string;
  title: string;
  path: string;
  snippet: string;
  tenant: string;  // org_slug — kept for SearchModal/SearchResults display
  docType: string; // collection_slug
}

export function useGlobalSearch(query: string, limit?: number) {
  const [results, setResults] = useState<SearchResult[]>([]);
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      return;
    }

    setIsSearching(true);
    const timer = setTimeout(async () => {
      try {
        const data = await api.search(query);
        const mapped: SearchResult[] = data.results.map(r => ({
          id: r.id,
          title: r.title,
          snippet: r.snippet,
          path: `/${r.org_slug}/${r.collection_slug}/${r.doc_slug}`,
          tenant: r.org_slug,
          docType: r.collection_slug,
        }));
        setResults(limit ? mapped.slice(0, limit) : mapped);
      } catch {
        setResults([]);
      } finally {
        setIsSearching(false);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [query, limit]);

  return { results, isSearching };
}
